import { render, staticRenderFns } from "./MessageBoxVue.vue?vue&type=template&id=2dc8354e&scoped=true"
import script from "./MessageBoxVue.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageBoxVue.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MessageBoxVue.vue?vue&type=style&index=0&id=2dc8354e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8354e",
  null
  
)

export default component.exports